/* Luraco i11 storefront, 2026-10-13 */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }

  // Home hero color swatches
  var hero = document.querySelector('[data-hero-img]');
  document.querySelectorAll('.i11-swatch').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!hero) return;
      document.querySelectorAll('.i11-swatch').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
      var src = b.getAttribute('data-src');
      hero.style.opacity = 0;
      setTimeout(function () {
        hero.src = src + '&width=1100';
        hero.srcset = src + '&width=640 640w, ' + src + '&width=900 900w, ' + src + '&width=1300 1300w';
        hero.alt = b.getAttribute('data-alt');
        hero.style.opacity = 1;
      }, 150);
    });
  });

  // PDP
  var jsonEl = document.querySelector('[data-product-json]');
  if (!jsonEl) return;
  var product = JSON.parse(jsonEl.textContent);
  var form = document.querySelector('[data-product-form]');
  var idInput = form && form.querySelector('[data-variant-id]');
  var mainImg = document.querySelector('[data-main-img]');
  var atc = form && form.querySelector('[data-atc]');
  var atcText = form && form.querySelector('[data-atc-text]');
  var orderLabel = atcText ? atcText.textContent.trim() : 'Add to cart';
  var thumbs = document.querySelectorAll('[data-thumb]');

  function showImage(src, srcset, alt, mediaId) {
    if (!mainImg) return;
    mainImg.style.opacity = 0;
    setTimeout(function () {
      mainImg.src = src; if (srcset) mainImg.srcset = srcset; mainImg.alt = alt || '';
      mainImg.style.opacity = 1;
    }, 120);
    thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-media-id')) === String(mediaId)); });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      showImage(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-alt'), t.getAttribute('data-media-id'));
    });
  });

  function selected() {
    return Array.prototype.map.call(form.querySelectorAll('.i11-opt'), function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  }
  function update() {
    var opts = selected();
    var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
    form.querySelectorAll('.i11-opt').forEach(function (fs, i) {
      var s = fs.querySelector('[data-option-value]'); if (s) s.textContent = opts[i];
    });
    if (!v) { atc.disabled = true; atcText.textContent = 'Unavailable'; return; }
    idInput.value = v.id;
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    document.querySelectorAll('[data-price]').forEach(function (p) { p.textContent = money(v.price); });
    atc.disabled = !v.available;
    atcText.textContent = v.available ? orderLabel : 'Sold out';
    if (v.featured_image) {
      var base = v.featured_image.src;
      var sep = base.indexOf('?') > -1 ? '&' : '?';
      showImage(base + sep + 'width=1100', base + sep + 'width=640 640w, ' + base + sep + 'width=1000 1000w, ' + base + sep + 'width=1400 1400w', v.featured_image.alt, v.featured_image.id);
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }
  if (form) form.querySelectorAll('.i11-opt input').forEach(function (i) { i.addEventListener('change', update); });

  // Sticky add-to-cart on mobile once the main button scrolls away
  var sticky = document.querySelector('[data-sticky]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    sticky.hidden = false; sticky.style.transform = 'translateY(110%)'; sticky.style.transition = 'transform .25s';
    new IntersectionObserver(function (e) {
      var show = !e[0].isIntersecting && e[0].boundingClientRect.top < 0 && window.innerWidth < 990;
      sticky.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
    }).observe(atc);
    var sb = sticky.querySelector('[data-sticky-atc]');
    if (sb) sb.addEventListener('click', function () { if (!atc.disabled) form.requestSubmit ? form.requestSubmit(atc) : atc.click(); });
  }
})();
